import config from '@efdigital/ll-xceed-v2/config/environment';
import EmberRouter from '@embroider/router';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('coaching', function () {
    this.route('coach', function () {
      this.route('help');
      this.route('settings', function () {
        this.route('availability');
        this.route('availability-preview');
      });
      this.route('sessions', function () {
        this.route('action-required');
        this.route('pending');
        this.route('past');
        this.route('canceled');
        this.route('history');
      });
      this.route('coachees', function () {
        this.route('coachee', { path: ':coachee_id' }, function () {
          this.route('past');
          this.route('canceled');
          this.route('goals', function () {
            this.route('goal', { path: ':goal_id' });
          });
          this.route('resources');
          this.route('about');
        });
      });
      this.route('messages', function () {
        this.route('conversation', { path: ':partnership_id' });
      });
    });
    this.route('coachee', function () {
      this.route('cohort', { path: ':program_id/:cohort_id' }, function () {
        this.route('coaches', function () {
          this.route('coach', { path: ':coach_id' }, function () {
            this.route('book-chemistry');
          });
          this.route('chosen');
          this.route('shortlist');
        });
        this.route('help');
        this.route('announcements');
        this.route('sessions', function () {
          this.route('action-required');
          this.route('pending');
          this.route('past');
          this.route('canceled');
          this.route('history');
          this.route('book-session');
        });
        this.route('goals', function () {
          this.route('goal', { path: ':goal_id' });
        });
        this.route('resources');
        this.route('messages', function () {
          this.route('conversation', { path: ':partnership_id' });
        });
        this.route('quiz');
      });
    });
  });
});
